'use client';

import { LazyLottie } from '../LazyLottie';
import { IAnimationProps } from '../types';

/**
 * -----------------------------------------------------------------------------
 * Renders a Lottie animation as an emoji blowing confetti, in default color.
 */
export function HappyEmojiDefaultColorAnimation(props: IAnimationProps) {
  const loadAnimation = () =>
    import('../raw-json/emojis/happy-emoji-default-color.json');

  return (
    <LazyLottie
      {...props}
      getAnimationData={loadAnimation}
      id="HappyEmojiDefaultColorAnimation"
    />
  );
}
